import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventHubHomeAll({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/EventHubHomeAll"));
  console.log("Loading", AsyncEventHubHomeAll.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventHubHomeAll;
